import bcsFetch from './Childs/bcsFetch'

export const handleInput = (e, wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar, isNew, error, setError) => {
  let newConf = { ...wcInventoryConf }
  if (isNew) {
    const rmError = { ...error }
    rmError[e.target.name] = ''
    setError({ ...rmError })
  }
  newConf[e.target.name] = e.target.value

  switch (e.target.name) {
    case 'orgId':
      newConf = portalChange(newConf, setWcInventoryConf, setisLoading, setSnackbar)
      getWarehouse(newConf,setWcInventoryConf)
      getSalespersons(newConf,setWcInventoryConf)
      break;
    default:
      break;
  }
  setWcInventoryConf(newConf)
}

export const getWarehouse = (wcInventoryConf, setWcInventoryConf) => {
  const requestParams = { orgId: wcInventoryConf.orgId,token:wcInventoryConf.tokenDetails.access_token, dataCenter:wcInventoryConf.dataCenter }
  bcsFetch(requestParams, 'bc_zoho_inventory_get_warehouse').then(
    (result) => {
      setWcInventoryConf(oldConf => {
        const newConf = { ...oldConf }
        if(result.data.code === 0 && result.data.warehouses) {
         newConf.default = { ...newConf.default, warehouses: result.data.warehouses }
        }else{
          newConf.default = { ...newConf.default, warehouses:[] }
        }
        return newConf
      })
    }
    )
}

export const getSalespersons = (wcInventoryConf, setWcInventoryConf) => {
  const requestParams = { orgId: wcInventoryConf.orgId,token:wcInventoryConf.tokenDetails.access_token, dataCenter:wcInventoryConf.dataCenter }
  bcsFetch(requestParams, 'bc_zoho_inventory_get_salespersons').then(
    (result) => {
      setWcInventoryConf(oldConf => {
        const newConf = { ...oldConf }
        if(result.data.code === 0 && result.data.data) {
         newConf.default = { ...newConf.default, salespersons: result.data.data }
        }else{
          newConf.default = { ...newConf.default, salespersons:[] }
        }
        return newConf

      })
    }
  )
}

export const portalChange = (wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar) => {
  const newConf = { ...wcInventoryConf }
  newConf.field_map = {
    inventoryCustomerFields: [{ formField: '', zohoFormField: '' }],
    inventorySalesFields: [{ formField: '', zohoFormField: '' }]
  }
  newConf.actions = {
    inventoryCustomer: {},
    inventorySales: {}
  }

  if (!newConf?.default?.allFields) {
    refreshFields(newConf, setWcInventoryConf, setisLoading, setSnackbar)
  } else newConf.field_map = generateMappedField(newConf)
  return newConf
}

export const refreshWarehouse = (wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar)=>{
  const newConf = {...wcInventoryConf}
  getWarehouse(newConf,setWcInventoryConf)
  getSalespersons(newConf,setWcInventoryConf)
  setSnackbar({ show: true, msg: 'Warehouse refreshed' })

}
export const refreshOrganizations = (wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar) => {
  setisLoading(true)
  const refreshOrganizationsRequestParams = {
    dataCenter: wcInventoryConf.dataCenter,
    clientId: wcInventoryConf.clientId,
    clientSecret: wcInventoryConf.clientSecret,
    tokenDetails: wcInventoryConf.tokenDetails,
  }
  bcsFetch(refreshOrganizationsRequestParams, 'bc_wc_refresh_organizations')
    .then(result => {
      if (result && result.success) {
        const newConf = { ...wcInventoryConf }
        if (result.data.organizations) {
          newConf.default = { ...newConf.default, organizations: result.data.organizations }
        }
        if (result.data.tokenDetails) {
          newConf.tokenDetails = result.data.tokenDetails
        }
        setSnackbar({ show: true, msg: 'Organizations refreshed' })
        setWcInventoryConf({ ...newConf })
      } else if ((result && result.data && result.data.data) || (!result.success && typeof result.data === 'string')) {
        setSnackbar({ show: true, msg: `Organizations refresh failed Cause:${result.data.data || result.data}. please try again` })
      } else {
        setSnackbar({ show: true, msg: 'Organizations refresh failed. please try again' })
      }
      setisLoading(false)
    })
    .catch(() => setisLoading(false))
}

export const refreshFields = (wcInventoryConf, setWcInventoryConf, setisLoading, setSnackbar) => {
  setisLoading(true)
  const refreshOrganizationsRequestParams = {
    dataCenter: wcInventoryConf.dataCenter,
    clientId: wcInventoryConf.clientId,
    clientSecret: wcInventoryConf.clientSecret,
    tokenDetails: wcInventoryConf.tokenDetails,
  }
  bcsFetch(refreshOrganizationsRequestParams, 'bc_wc_refresh_fields')
    .then(result => {
      if (result && result.success) {
        setWcInventoryConf(oldConf => {
          const newConf = { ...oldConf }
          newConf.default = {
            ...newConf.default,
            allFields: {
              wcCheckoutFields: result.data.wcCheckoutFields,
              inventoryCustomerFields: result.data.inventoryCustomerFields,
              inventorySalesFields: result.data.inventorySalesFields
            }
          }
  
          newConf.field_map = generateMappedField(newConf)
          if (result.data.tokenDetails) {
            newConf.tokenDetails = result.data.tokenDetails
          }
          return newConf
        })
        setSnackbar({ show: true, msg: 'WooCommerce Checkout Fields refreshed' })
      } else if ((result && result.data && result.data.data) || (!result.success && typeof result.data === 'string')) {
        setSnackbar({ show: true, msg: `WooCommerce Checkout Fields refresh failed Cause:${result.data.data || result.data}. please try again` })
      } else {
        setSnackbar({ show: true, msg: 'WooCommerce Checkout Fields refresh failed. please try again' })
      }
      setisLoading(false)
    })
    .catch(() => setisLoading(false))
}

export const generateMappedField = wcInventoryConf => {
  const fldMap = {}
  const fldTypes = ['inventoryCustomerFields', 'inventorySalesFields']
  fldTypes.map(fldType => {
    fldMap[fldType] = wcInventoryConf.default.allFields[fldType].required.length > 0 ? wcInventoryConf.default.allFields[fldType].required?.map(field => ({ formField: '', zohoFormField: field })) : [{ formField: '', zohoFormField: '' }]
  })
  return fldMap
}

export const checkMappedFields = wcInventoryConf => {

  const isNotMapped = ['inventoryCustomerFields', 'inventorySalesFields'].map(fldType =>
    wcInventoryConf?.field_map?.[fldType] ? wcInventoryConf.field_map[fldType].filter(mappedField => (!mappedField.formField && mappedField.zohoFormField && wcInventoryConf?.default?.allFields?.[fldType]?.required.indexOf(mappedField.zohoFormField) !== -1)) : []
  )
  if (isNotMapped[0].length || isNotMapped[1].length) {
    return false
  }
  return true
}
